import React from 'react';
import { LAST_YEAR } from '../../utils/helpers';
import EnhancedEligibilityDescription from './EnhancedEligibilityDescription';

const FinancialOnboardingDescription = (
  <>
    <p>
      Next we’ll ask about your household financial information from {LAST_YEAR}
      . We’ll ask about income and expenses for you, your spouse (if you’re
      married), and any dependents you may have.
    </p>
    <p>
      It’s your choice whether you want to share your financial information.
      Before you decide, here’s what to know about how we’ll use your financial
      information.
    </p>
    <p>
      <strong>
        We use your financial information to determine these factors:
      </strong>
    </p>
    <ul>
      <li>
        <strong>
          If you’re eligible for VA healthcare based on your income.
        </strong>{' '}
        You may be eligible based on factors other than your income. We call
        these “enhanced eligibility status” factors. If you don’t have one of
        these factors, we’ll use your income to decide if you’re eligible.
      </li>
      <li>
        <strong>If you’re eligible for travel pay reimbursement.</strong>{' '}
        Reimbursement means we pay you back for the cost of travel to and from
        your VA health appointments.
      </li>
      <li>
        <strong>
          If you’ll need to pay a copay for non-service-connected care or
          prescription medicines.
        </strong>{' '}
        This means you may need to pay a fixed amount for some types of care or
        medications you receive from a VA healthcare provider or an approved
        community care provider.
      </li>
    </ul>

    <p>
      <strong>Note:</strong> We verify the financial information you provide
      with the Internal Revenue Service (IRS).
    </p>

    <EnhancedEligibilityDescription />
  </>
);

export default FinancialOnboardingDescription;
